import { render, staticRenderFns } from "./UnboxControls.vue?vue&type=template&id=9dab182c&scoped=true"
import script from "./UnboxControls.vue?vue&type=script&lang=js"
export * from "./UnboxControls.vue?vue&type=script&lang=js"
import style0 from "./UnboxControls.vue?vue&type=style&index=0&id=9dab182c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dab182c",
  null
  
)

export default component.exports